import styled from 'styled-components'

export const MessageWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 6px;
  color: var(--sale);
  font-weight: var(--font-medium);
  line-height: 1.1;
  font-size: 13px;
  padding: 6px 0;

  svg {
    position: relative;
    top: -1px;
    width: 15px;
    height: 15px;
    flex-shrink: 0;
  }
`
